<template>
    <div class="card card-primary">
        <div class="card-header">
            <h3 class="card-title">{{ $t('general.automatico') }}</h3>
        </div>
        <div align="center" class="card-body">
            <button type="button" class="btn btn-default reparto automatico">{{ $t('general.automatico') }}</button>
        </div>
    </div>
</template>